import comp from "./BulkApplyModuleAccessLevel";
export default comp;
